import React from 'react'

const SongwriterHeader = () => (
    <>
        <h1>
            Welcome to
            <br /> The Songwriter Hub
        </h1>
    </>
)
export default SongwriterHeader
